<template>
  <GiftRowBase
    :img="'https://mylastwill.s3.amazonaws.com/static/img/button-gift-property.png'"
    :description="description"
    :shared="gift.beneficiary_group_share"
    :beneficiary="gift.beneficiary_group || gift.beneficiary.full_name"
    @editGift="$emit('editPropertyGift')"
    @deleteGift="$emit('deletePropertyGift')"
  >
  </GiftRowBase>
</template>

<script>
import GiftRowBase from './RowBase'
import { TextFormat } from '@/common/mixins/TextFormat'

export default {
  name: 'GiftRowProperty',
  props: ['gift'],
  mixins: [TextFormat],
  components: {
    GiftRowBase
  },
  computed: {
    description() {
      return this.truncate(
        this.gift.address_line_1 + ', ' + this.gift.post_code,
        20
      )
    }
  }
}
</script>
